module.exports = __webpack_public_path__ + "static/media/animal-chimpanzee1.e74ed6e4.aac";